import React  from 'react';

import styles from './bottom-bar.module.css';

export type BottomBarProps = React.HTMLAttributes<HTMLDivElement>

export const BottomBar = ({children}: BottomBarProps)=> {
  return (
    <div className={styles.wrapper}>
      {children}
    </div>
  )
};
